import { useId, useMemo } from 'react';
import logoMarkMarkup from '../../assets/brand/ld-logo-wot.svg?raw';
import logoMarkup from '../../assets/brand/ld-logo-wt.svg?raw';

interface BrandLogoProps {
  className?: string;
  compact?: boolean;
}

function scopeSvgIds(markup: string, prefix: string) {
  const document = new DOMParser().parseFromString(markup, 'image/svg+xml');
  const svg = document.documentElement;
  const ids = new Map<string, string>();

  svg.querySelectorAll('[id]').forEach((element) => {
    const currentId = element.id;
    const scopedId = `${prefix}-${currentId}`;
    ids.set(currentId, scopedId);
    element.id = scopedId;
  });

  svg.querySelectorAll('*').forEach((element) => {
    for (const attribute of Array.from(element.attributes)) {
      let value = attribute.value;

      ids.forEach((scopedId, currentId) => {
        value = value.replaceAll(`url(#${currentId})`, `url(#${scopedId})`);
        if (value === `#${currentId}`) value = `#${scopedId}`;
      });

      if (value !== attribute.value) element.setAttribute(attribute.name, value);
    }
  });

  return new XMLSerializer().serializeToString(svg);
}

export function BrandLogo({ className, compact = false }: BrandLogoProps) {
  const instanceId = useId().replaceAll(':', '');
  const scopedMarkup = useMemo(
    () => scopeSvgIds(compact ? logoMarkMarkup : logoMarkup, `brand-logo-${instanceId}`),
    [compact, instanceId],
  );

  return (
    <span
      className={className}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: scopedMarkup }}
    />
  );
}
